module.exports = __webpack_public_path__ + "public/media/step_1_draw_volcano.low.945f4ab7.mp4";